// Zip code to city mapping for 50 major global cities supported by FlameLink
export const zipCodeToCityMapping = {
  // United States - Major Cities
  // New York, NY
  "10001": "New York, NY", "10002": "New York, NY", "10003": "New York, NY", "10009": "New York, NY", "10010": "New York, NY",
  "10011": "New York, NY", "10012": "New York, NY", "10013": "New York, NY", "10014": "New York, NY", "10016": "New York, NY",
  "10017": "New York, NY", "10018": "New York, NY", "10019": "New York, NY", "10020": "New York, NY", "10021": "New York, NY",
  "10022": "New York, NY", "10023": "New York, NY", "10024": "New York, NY", "10025": "New York, NY", "10026": "New York, NY",
  "10027": "New York, NY", "10028": "New York, NY", "10029": "New York, NY", "10030": "New York, NY", "10031": "New York, NY",

  // East Los Angeles, CA
  "90001": "East Los Angeles, CA", "90002": "East Los Angeles, CA", "90003": "East Los Angeles, CA", "90004": "East Los Angeles, CA", "90005": "East Los Angeles, CA",
  "90010": "East Los Angeles, CA", "90028": "East Los Angeles, CA", "90036": "East Los Angeles, CA",

  // West Los Angeles, CA  
  "90024": "West Los Angeles, CA", "90025": "West Los Angeles, CA", "90064": "West Los Angeles, CA", "90210": "West Los Angeles, CA", "90211": "West Los Angeles, CA",
  "90272": "West Los Angeles, CA", "90291": "West Los Angeles, CA", "90401": "West Los Angeles, CA", "90403": "West Los Angeles, CA", "90404": "West Los Angeles, CA",

  // Orange County, CA
  "90620": "Orange County, CA", "90621": "Orange County, CA", "90630": "Orange County, CA", "92602": "Orange County, CA", "92603": "Orange County, CA",
  "92604": "Orange County, CA", "92606": "Orange County, CA", "92612": "Orange County, CA", "92614": "Orange County, CA", "92617": "Orange County, CA",

  // Chicago, IL
  "60601": "Chicago, IL", "60602": "Chicago, IL", "60603": "Chicago, IL", "60604": "Chicago, IL", "60605": "Chicago, IL",
  "60610": "Chicago, IL", "60611": "Chicago, IL", "60612": "Chicago, IL", "60613": "Chicago, IL", "60614": "Chicago, IL",

  // Houston, TX
  "77001": "Houston, TX", "77002": "Houston, TX", "77003": "Houston, TX", "77004": "Houston, TX", "77005": "Houston, TX",
  "77010": "Houston, TX", "77020": "Houston, TX", "77030": "Houston, TX", "77040": "Houston, TX", "77050": "Houston, TX",

  // Phoenix, AZ
  "85001": "Phoenix, AZ", "85002": "Phoenix, AZ", "85003": "Phoenix, AZ", "85004": "Phoenix, AZ", "85005": "Phoenix, AZ",
  "85010": "Phoenix, AZ", "85020": "Phoenix, AZ", "85030": "Phoenix, AZ", "85040": "Phoenix, AZ", "85050": "Phoenix, AZ",

  // Philadelphia, PA
  "19101": "Philadelphia, PA", "19102": "Philadelphia, PA", "19103": "Philadelphia, PA", "19104": "Philadelphia, PA", "19105": "Philadelphia, PA",
  "19110": "Philadelphia, PA", "19111": "Philadelphia, PA", "19120": "Philadelphia, PA", "19130": "Philadelphia, PA", "19140": "Philadelphia, PA",

  // San Francisco, CA
  "94101": "San Francisco, CA", "94102": "San Francisco, CA", "94103": "San Francisco, CA", "94104": "San Francisco, CA", "94105": "San Francisco, CA",
  "94110": "San Francisco, CA", "94115": "San Francisco, CA", "94120": "San Francisco, CA", "94130": "San Francisco, CA", "94140": "San Francisco, CA",

  // Seattle, WA
  "98101": "Seattle, WA", "98102": "Seattle, WA", "98103": "Seattle, WA", "98104": "Seattle, WA", "98105": "Seattle, WA",
  "98110": "Seattle, WA", "98115": "Seattle, WA", "98120": "Seattle, WA", "98125": "Seattle, WA", "98130": "Seattle, WA",

  // Denver, CO
  "80201": "Denver, CO", "80202": "Denver, CO", "80203": "Denver, CO", "80204": "Denver, CO", "80205": "Denver, CO",
  "80210": "Denver, CO", "80220": "Denver, CO", "80230": "Denver, CO", "80240": "Denver, CO", "80250": "Denver, CO",

  // Boston, MA
  "02101": "Boston, MA", "02102": "Boston, MA", "02103": "Boston, MA", "02104": "Boston, MA", "02105": "Boston, MA",
  "02110": "Boston, MA", "02115": "Boston, MA", "02120": "Boston, MA", "02125": "Boston, MA", "02130": "Boston, MA",

  // Miami, FL
  "33101": "Miami, FL", "33102": "Miami, FL", "33109": "Miami, FL", "33111": "Miami, FL", "33112": "Miami, FL",
  "33120": "Miami, FL", "33125": "Miami, FL", "33130": "Miami, FL", "33135": "Miami, FL", "33140": "Miami, FL",

  // PACIFIC REGION
  // Honolulu, HI
  "96801": "Honolulu, HI", "96802": "Honolulu, HI", "96803": "Honolulu, HI", "96804": "Honolulu, HI", "96805": "Honolulu, HI",
  "96810": "Honolulu, HI", "96815": "Honolulu, HI", "96820": "Honolulu, HI", "96825": "Honolulu, HI", "96830": "Honolulu, HI",

  // Maui, HI  
  "96708": "Maui, HI", "96713": "Maui, HI", "96729": "Maui, HI", "96732": "Maui, HI", "96753": "Maui, HI",
  "96761": "Maui, HI", "96768": "Maui, HI", "96784": "Maui, HI", "96790": "Maui, HI", "96793": "Maui, HI",

  // Guam
  "96910": "Guam", "96911": "Guam", "96912": "Guam", "96913": "Guam", "96915": "Guam",
  "96916": "Guam", "96917": "Guam", "96919": "Guam", "96921": "Guam", "96923": "Guam",

  // ASIA REGION
  // Tokyo, Japan (using postal code format)
  "100000": "Tokyo, Japan", "101000": "Tokyo, Japan", "102000": "Tokyo, Japan", "103000": "Tokyo, Japan", "104000": "Tokyo, Japan",
  "150000": "Tokyo, Japan", "151000": "Tokyo, Japan", "152000": "Tokyo, Japan", "160000": "Tokyo, Japan", "170000": "Tokyo, Japan",

  // Seoul, South Korea
  "03000": "Seoul, South Korea", "04000": "Seoul, South Korea", "05000": "Seoul, South Korea", "06000": "Seoul, South Korea", "07000": "Seoul, South Korea",
  "08000": "Seoul, South Korea", "09000": "Seoul, South Korea", "10000": "Seoul, South Korea", "11000": "Seoul, South Korea", "12000": "Seoul, South Korea",

  // Shanghai, China
  "200001": "Shanghai, China", "200010": "Shanghai, China", "200020": "Shanghai, China", "200030": "Shanghai, China", "200040": "Shanghai, China",
  "201100": "Shanghai, China", "201200": "Shanghai, China", "201300": "Shanghai, China", "201400": "Shanghai, China", "201500": "Shanghai, China",

  // Taipei, Taiwan (using 6-digit format to avoid conflicts)
  "100410": "Taipei, Taiwan", "100420": "Taipei, Taiwan", "100430": "Taipei, Taiwan", "100440": "Taipei, Taiwan", "100450": "Taipei, Taiwan",
  "100460": "Taipei, Taiwan", "100470": "Taipei, Taiwan", "100480": "Taipei, Taiwan", "100490": "Taipei, Taiwan", "100500": "Taipei, Taiwan",

  // CANADA REGION
  // Toronto, Canada (using simplified postal format)
  "M5V123": "Toronto, Canada", "M5H456": "Toronto, Canada", "M4E789": "Toronto, Canada", "M4S012": "Toronto, Canada", "M6G345": "Toronto, Canada",
  "M6H678": "Toronto, Canada", "M6J901": "Toronto, Canada", "M6K234": "Toronto, Canada", "M6R567": "Toronto, Canada", "M4P890": "Toronto, Canada",

  // Vancouver, Canada
  "V6B123": "Vancouver, Canada", "V6C456": "Vancouver, Canada", "V6E789": "Vancouver, Canada", "V6G012": "Vancouver, Canada", "V6H345": "Vancouver, Canada",
  "V6J678": "Vancouver, Canada", "V6K901": "Vancouver, Canada", "V6L234": "Vancouver, Canada", "V6M567": "Vancouver, Canada", "V6N890": "Vancouver, Canada"
};

export const checkZipCodeSupport = (zipCode) => {
  const supportedCity = zipCodeToCityMapping[zipCode];
  
  if (supportedCity) {
    return {
      isSupported: true,
      city: supportedCity
    };
  }
  
  return {
    isSupported: false,
    city: null
  };
};